export default __webpack_public_path__ + "static/media/sponsors.c6363519.svg";